import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';
import { login } from '../services/authService';
import Popup from '../components/Popup/Popup';
import { useApi } from '../hooks/useApi';
import logo from '../images/logo.png';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [popup, setPopup] = useState(null);
  const navigate = useNavigate();
  const { callApi } = useApi();

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await callApi(() => login(username, password));
      
      if (result.success && result.data) {
        localStorage.setItem('token', result.data.access_token);
        localStorage.setItem('user', JSON.stringify(result.data.staff));
        navigate('/dashboard');
      } else {
        setPopup({ 
          type: 'error', 
          message: result.message || 'Đăng nhập thất bại. Vui lòng thử lại.'
        });
      }
    } catch (error) {
      console.error('Đăng nhập thất bại:', error);
      setPopup({ 
        type: 'error', 
        message: 'Đăng nhập thất bại. Vui lòng thử lại.'
      });
    }
  };

  const closePopup = () => {
    setPopup(null);
  };

  return (
    <div className="loginscr-container">
      <form className="loginscr-form" onSubmit={handleSubmit}>
        <div className="loginscr-logo-container">
          <img src={logo} alt="Logo" className="loginscr-logo" />
        </div>
        <h2 className="loginscr-title">Đăng nhập</h2>
        <div className="loginscr-form-group">
          <label className="loginscr-label" htmlFor="username">Tên đăng nhập:</label>
          <input
            className="loginscr-input"
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="loginscr-form-group">
          <label className="loginscr-label" htmlFor="password">Mật khẩu:</label>
          <input
            className="loginscr-input"
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button className="loginscr-button" type="submit">Đăng nhập</button>
      </form>
      {popup && (
        <Popup
          type={popup.type}
          message={popup.message}
          onClose={closePopup}
        />
      )}
    </div>
  );
}

export default Login;
